// A loja imprime o cupom de preparo? (Sistema → Preferências). `null` enquanto
// carrega; erro de rede = true (na dúvida, a tela se comporta como sempre).
import { useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";

export function usePreparoAtivo() {
  const [ativo, setAtivo] = useState(null);
  useEffect(() => {
    let vivo = true;
    fetch(`${API_URL}/api/settings/preparo`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` },
      cache: "no-store",
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (vivo) setAtivo(d?.ativo !== false); })
      .catch(() => { if (vivo) setAtivo(true); });
    return () => { vivo = false; };
  }, []);
  return ativo;
}
